var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoAppt(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 88,
    viewBox: "0 0 89 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "appointment 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M75 11V19.25H6.25V11C6.25 9.4875 7.4875 8.25 9 8.25H72.25C73.7625 8.25 75 9.4875 75 11Z",
    fill: "url(#paint0_linear_9595_20346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M75 19.25V74.25C75 75.7625 73.7625 77 72.25 77H9C7.4875 77 6.25 75.7625 6.25 74.25V19.25H75Z",
    fill: "url(#paint1_linear_9595_20346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M40.625 12.375C39.8687 12.375 39.25 11.7562 39.25 11V5.5C39.25 4.74375 39.8687 4.125 40.625 4.125C41.3812 4.125 42 4.74375 42 5.5V11C42 11.7562 41.3812 12.375 40.625 12.375Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.25 12.375C27.4937 12.375 26.875 11.7562 26.875 11V5.5C26.875 4.74375 27.4937 4.125 28.25 4.125C29.0062 4.125 29.625 4.74375 29.625 5.5V11C29.625 11.7562 29.0062 12.375 28.25 12.375Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M15.875 12.375C15.1187 12.375 14.5 11.7562 14.5 11V5.5C14.5 4.74375 15.1187 4.125 15.875 4.125C16.6312 4.125 17.25 4.74375 17.25 5.5V11C17.25 11.7562 16.6312 12.375 15.875 12.375Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M53 12.375C52.2437 12.375 51.625 11.7562 51.625 11V5.5C51.625 4.74375 52.2437 4.125 53 4.125C53.7562 4.125 54.375 4.74375 54.375 5.5V11C54.375 11.7562 53.7562 12.375 53 12.375Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M65.375 12.375C64.6187 12.375 64 11.7562 64 11V5.5C64 4.74375 64.6187 4.125 65.375 4.125C66.1312 4.125 66.75 4.74375 66.75 5.5V11C66.75 11.7562 66.1312 12.375 65.375 12.375Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M18.625 27.5H13.125C12.3656 27.5 11.75 28.1156 11.75 28.875V34.375C11.75 35.1344 12.3656 35.75 13.125 35.75H18.625C19.3844 35.75 20 35.1344 20 34.375V28.875C20 28.1156 19.3844 27.5 18.625 27.5Z",
    fill: "url(#paint2_linear_9595_20346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M35.125 27.5H29.625C28.8656 27.5 28.25 28.1156 28.25 28.875V34.375C28.25 35.1344 28.8656 35.75 29.625 35.75H35.125C35.8844 35.75 36.5 35.1344 36.5 34.375V28.875C36.5 28.1156 35.8844 27.5 35.125 27.5Z",
    fill: "url(#paint3_linear_9595_20346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M51.625 27.5H46.125C45.3656 27.5 44.75 28.1156 44.75 28.875V34.375C44.75 35.1344 45.3656 35.75 46.125 35.75H51.625C52.3844 35.75 53 35.1344 53 34.375V28.875C53 28.1156 52.3844 27.5 51.625 27.5Z",
    fill: "url(#paint4_linear_9595_20346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M68.125 27.5H62.625C61.8656 27.5 61.25 28.1156 61.25 28.875V34.375C61.25 35.1344 61.8656 35.75 62.625 35.75H68.125C68.8844 35.75 69.5 35.1344 69.5 34.375V28.875C69.5 28.1156 68.8844 27.5 68.125 27.5Z",
    fill: "url(#paint5_linear_9595_20346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M18.625 44H13.125C12.3656 44 11.75 44.6156 11.75 45.375V50.875C11.75 51.6344 12.3656 52.25 13.125 52.25H18.625C19.3844 52.25 20 51.6344 20 50.875V45.375C20 44.6156 19.3844 44 18.625 44Z",
    fill: "url(#paint6_linear_9595_20346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M35.125 44H29.625C28.8656 44 28.25 44.6156 28.25 45.375V50.875C28.25 51.6344 28.8656 52.25 29.625 52.25H35.125C35.8844 52.25 36.5 51.6344 36.5 50.875V45.375C36.5 44.6156 35.8844 44 35.125 44Z",
    fill: "url(#paint7_linear_9595_20346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M51.625 44H46.125C45.3656 44 44.75 44.6156 44.75 45.375V50.875C44.75 51.6344 45.3656 52.25 46.125 52.25H51.625C52.3844 52.25 53 51.6344 53 50.875V45.375C53 44.6156 52.3844 44 51.625 44Z",
    fill: "url(#paint8_linear_9595_20346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M68.125 44H62.625C61.8656 44 61.25 44.6156 61.25 45.375V50.875C61.25 51.6344 61.8656 52.25 62.625 52.25H68.125C68.8844 52.25 69.5 51.6344 69.5 50.875V45.375C69.5 44.6156 68.8844 44 68.125 44Z",
    fill: "url(#paint9_linear_9595_20346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M18.625 60.5H13.125C12.3656 60.5 11.75 61.1156 11.75 61.875V67.375C11.75 68.1344 12.3656 68.75 13.125 68.75H18.625C19.3844 68.75 20 68.1344 20 67.375V61.875C20 61.1156 19.3844 60.5 18.625 60.5Z",
    fill: "url(#paint10_linear_9595_20346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M35.125 60.5H29.625C28.8656 60.5 28.25 61.1156 28.25 61.875V67.375C28.25 68.1344 28.8656 68.75 29.625 68.75H35.125C35.8844 68.75 36.5 68.1344 36.5 67.375V61.875C36.5 61.1156 35.8844 60.5 35.125 60.5Z",
    fill: "url(#paint11_linear_9595_20346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M51.625 60.5H46.125C45.3656 60.5 44.75 61.1156 44.75 61.875V67.375C44.75 68.1344 45.3656 68.75 46.125 68.75H51.625C52.3844 68.75 53 68.1344 53 67.375V61.875C53 61.1156 52.3844 60.5 51.625 60.5Z",
    fill: "url(#paint12_linear_9595_20346)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M70.875 82.5C77.7095 82.5 83.25 76.9595 83.25 70.125C83.25 63.2905 77.7095 57.75 70.875 57.75C64.0405 57.75 58.5 63.2905 58.5 70.125C58.5 76.9595 64.0405 82.5 70.875 82.5Z",
    fill: "#347BFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M71.8347 77.9796C71.582 78.2324 71.2417 78.3782 70.8625 78.3879C70.1041 78.3879 69.4916 77.7754 69.4916 77.017V63.2691C69.4916 62.5107 70.1041 61.8982 70.8625 61.8982C71.6208 61.8982 72.2334 62.5107 72.2334 63.2691V77.017C72.2334 77.4059 72.0778 77.7365 71.825 77.9893L71.8347 77.9796Z",
    fill: "url(#paint13_linear_9595_20346)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M78.7194 71.0958C78.4667 71.3486 78.1264 71.4945 77.7472 71.5042L63.9993 71.5042C63.2409 71.5042 62.6283 70.8917 62.6283 70.1333C62.6283 69.3749 63.2409 68.7624 63.9993 68.7624L77.7472 68.7624C78.5056 68.7624 79.1181 69.3749 79.1181 70.1333C79.1181 70.5222 78.9625 70.8528 78.7097 71.1056L78.7194 71.0958Z",
    fill: "url(#paint14_linear_9595_20346)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9595_20346",
    x1: 20.2518,
    y1: 8.16609,
    x2: 20.3784,
    y2: 19.2102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9595_20346",
    x1: 6.25117,
    y1: 48.125,
    x2: 75.0004,
    y2: 48.125,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E9F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CADCF0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9595_20346",
    x1: 13.4302,
    y1: 27.4371,
    x2: 14.0207,
    y2: 35.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_9595_20346",
    x1: 29.9302,
    y1: 27.4371,
    x2: 30.5207,
    y2: 35.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_9595_20346",
    x1: 46.4302,
    y1: 27.4371,
    x2: 47.0207,
    y2: 35.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_9595_20346",
    x1: 62.9302,
    y1: 27.4371,
    x2: 63.5207,
    y2: 35.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_9595_20346",
    x1: 13.4302,
    y1: 43.9371,
    x2: 14.0207,
    y2: 52.1789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_9595_20346",
    x1: 29.9302,
    y1: 43.9371,
    x2: 30.5207,
    y2: 52.1789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_9595_20346",
    x1: 46.4302,
    y1: 43.9371,
    x2: 47.0207,
    y2: 52.1789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_9595_20346",
    x1: 62.9302,
    y1: 43.9371,
    x2: 63.5207,
    y2: 52.1789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_9595_20346",
    x1: 13.4302,
    y1: 60.4371,
    x2: 14.0207,
    y2: 68.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_9595_20346",
    x1: 29.9302,
    y1: 60.4371,
    x2: 30.5207,
    y2: 68.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_9595_20346",
    x1: 46.4302,
    y1: 60.4371,
    x2: 47.0207,
    y2: 68.6789,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_9595_20346",
    x1: 63.7766,
    y1: 68.2808,
    x2: 73.2097,
    y2: 76.4529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_9595_20346",
    x1: 63.7874,
    y1: 68.2711,
    x2: 73.2204,
    y2: 76.4431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CADCF0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A4BBDB"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoAppt);
export default __webpack_public_path__ + "static/media/noAppt.ba71159f3b81556cc999d239df15fe63.svg";
export { ForwardRef as ReactComponent };